export function resizeContainer(): void {
	const container = document.getElementById("container");
	const baseWidth = 128;
	const baseHeight = 128;
	if (container === null) {
		throw new Error("Container not found");
	}
	const windowWidth = window.innerWidth;
	const windowHeight = window.innerHeight;
	const scale = Math.min(windowWidth / baseWidth, windowHeight / baseHeight);

	container.style.width = baseWidth + "px";
	container.style.height = baseHeight + "px";
	container.style.transform = `scale(${scale})`;

	// Center the container
	container.style.left = (windowWidth - baseWidth * scale) / 2 + "px";
	container.style.top = (windowHeight - baseHeight * scale) / 2 + "px";

	// Update font size for buttons (and other text elements)

	container.style.fontSize = scale + "em";
}

async function init(): Promise<void> {
	const container = document.getElementById("container");
	const baseWidth = 128;
	const baseHeight = 128;

	function resizeContainer(): void {
		if (container === null) {
			throw new Error("Container not found");
		}
		const windowWidth = window.innerWidth;
		const windowHeight = window.innerHeight;
		const scale = Math.min(windowWidth / baseWidth, windowHeight / baseHeight);

		container.style.width = baseWidth + "px";
		container.style.height = baseHeight + "px";
		container.style.transform = `scale(${scale})`;

		// Center the container
		container.style.left = (windowWidth - baseWidth * scale) / 2 + "px";
		container.style.top = (windowHeight - baseHeight * scale) / 2 + "px";

		// Update font size for buttons (and other text elements)
		container.style.fontSize = scale + "em";
	}

	// Initial resize
	resizeContainer();

	// Resize on window size change
	window.addEventListener("resize", resizeContainer);
}

init();
